import { ACTUAL_PAGE } from './../constants';
import { handleActions } from "redux-actions"

export const navigation  = handleActions(
  {
    [ ACTUAL_PAGE ]: (state, action) => action.payload 
  }, {}
)